import { Action, ActionType, State } from './types'

/**
 * Export template dialog reducer.
 *
 * @param {State} state
 * @param {Action} action
 * @returns {State}
 */
export function reducer(state: State, action: Action) {
  switch (action.type) {
    case ActionType.setSelected: {
      return {
        ...state,
        selected: action.payload.selected,
      }
    }
    case ActionType.setFileType: {
      return {
        ...state,
        fileType: action.payload.fileType,
      }
    }
    case ActionType.setEmail: {
      return {
        ...state,
        email: action.payload.email,
      }
    }
    case ActionType.resetState: {
      const { selected, fileType, email } = action.payload

      return {
        selected,
        fileType,
        email,
      }
    }
    default:
      return state
  }
}
